module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/notokr-regular.woff
// module id = UZiK
// module chunks = 0